<template>
  <svg width="14px" height="12px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="6.75 6.75 11.25 11.25">
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Task-Report---Task" transform="translate(-400.000000, -635.000000)">
        <g id="List" transform="translate(370.000000, 551.000000)">
          <g id="Molecules/Task/Log" transform="translate(0.000000, 60.000000)">
            <g id="Label" transform="translate(5.000000, 4.000000)">
              <g id="Variables/Icon/Images" transform="translate(25.000000, 20.000000)">
                <g id="Icon" fill="#cdd0d4" fill-rule="nonzero">
                  <path
                      d="M16.74,18 C17.08,18 17.375,17.875 17.625,17.625 C17.875,17.375 18,17.08 18,16.74 L18,16.74 L18,8.01 C18,7.67 17.875,7.375 17.625,7.125 C17.375,6.875 17.08,6.75 16.74,6.75 L16.74,6.75 L8.01,6.75 C7.67,6.75 7.375,6.875 7.125,7.125 C6.875,7.375 6.75,7.67 6.75,8.01 L6.75,8.01 L6.75,16.74 C6.75,17.08 6.875,17.375 7.125,17.625 C7.375,17.875 7.67,18 8.01,18 L8.01,18 L16.74,18 Z M16.74,16.125 L8.01,16.125 L10.185,13.305 L11.76,15.18 L13.935,12.375 L16.74,16.125 Z"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TaskIcon',
};
</script>

<style scoped>

</style>
